export const educationData = [
    {
        id: 1,
        institution: 'Kalinga Institute of Industrial Technology',
        course: 'Bachelor Degree',
        startYear: '2021',
        endYear: '2024',
        grade: '9.35 / 10'
    },
    {
        id: 2,
        institution: 'College Alfajiri',
        course: 'Secondary School',
        startYear: '2014',
        endYear: '2020',
        grade: '83%'
    },
    {
        id: 3,
        institution: 'Ep1 Ibanda',
        course: 'Primary School',
        startYear: '2008',
        endYear: '2014',
        grade: '93%'
    },
]